'use client';

import { trackEvent } from '@repo/web-chrome/lib/analytics';
import { useEffect } from 'react';

interface INotFoundTelemetryProps {
  path: string;
  locale: string;
}

export function NotFoundTelemetry({ path, locale }: INotFoundTelemetryProps): null {
  useEffect(() => {
    trackEvent('page_not_found', {
      path,
      locale,
      referrer: document.referrer || '',
    });
  }, [path, locale]);
  return null;
}
